import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { EmptyState, TableBody, TableHead, TableHeadCell, TableHeaderText, TableRow } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { ProjectRow } from './ProjectRow';
import { PickerContent } from '../PickerContent';
import { StyledTable } from '../PickerTableFilesystem/styled';
export function ProjectTable(props) {
    const { projects, selected, loading, onToggle } = props;
    if (!projects.length && !loading) {
        return (<PickerContent>
        <EmptyState withAvatar icon={<Falcon icon="search"/>} title={t({ comment: 'When a search does not return any results - Title', message: 'No results' })} description={t({
                comment: 'When a search does not return any results - Description',
                message: 'We could not find any results for your search.',
            })}/>
      </PickerContent>);
    }
    return (<PickerContent>
      <StyledTable dense>
        <colgroup>
          <col width="auto"/>
          <col width="140"/>
          <col width="100"/>
          <col width="140"/>
        </colgroup>
        <TableHead>
          <TableRow>
            <TableHeadCell id="cell:name">
              <TableHeaderText>
                <Trans comment="Table column header: Title">Title</Trans>
              </TableHeaderText>
            </TableHeadCell>
            <TableHeadCell id="cell:customerId">
              <TableHeaderText>
                <Trans comment="Table column header: Project ID">Project ID</Trans>
              </TableHeaderText>
            </TableHeadCell>
            <TableHeadCell id="cell:documents">
              <TableHeaderText>
                <Trans comment="Table column header: Documents">Documents</Trans>
              </TableHeaderText>
            </TableHeadCell>
            <TableHeadCell id="cell:status">
              <TableHeaderText>
                <Trans comment="Table column header: Status">Status</Trans>
              </TableHeaderText>
            </TableHeadCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {projects.map((project) => (<ProjectRow key={project.id} project={project} selected={selected.some(({ id }) => id === project.id)} onToggle={onToggle}/>))}
        </TableBody>
      </StyledTable>
    </PickerContent>);
}
